import React from 'react';
import { ButtonText, StyledButton } from './styled';
import { Loader } from './loader.styled';
import { ButtonType } from '../../../styled/theme/types';
import { ButtonProps } from './types';
import { globalSystemColors } from '../../../styled/theme/constants';

export const Button: React.FC<ButtonProps> = ({
  type = 'button',
  name,
  text = '',
  children,
  disabled = false,
  loading = false,
  isSmall = false,
  state = ButtonType.default,
  styles,
  onClick,
  onKeyPress,
  stat,
  cypress,
  hover,
  ariaLabel,
  background
}) => (
  <StyledButton
    data-cy={cypress}
    data-stat={stat}
    disabled={disabled}
    $isSmall={isSmall}
    $state={state}
    type={type}
    name={name}
    onClick={onClick}
    onKeyPress={onKeyPress}
    $styles={styles}
    $hover={hover}
    $bg={background}
    aria-label={ariaLabel}
  >
    {loading ? (
      <Loader $color={state === ButtonType.delete && globalSystemColors.red} />
    ) : (
      <ButtonText
        tag="body_1"
        $state={state}
        $disabled={disabled}
        aria-label={ariaLabel || (typeof text === 'string' ? text : undefined)}
      >
        {children}
        {text}
      </ButtonText>
    )}
  </StyledButton>
);
